"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SAMPLE_OR_PARENT_BUTTON = void 0;
const SAMPLE_OR_PARENT_BUTTON = exports.SAMPLE_OR_PARENT_BUTTON = 'sample-or-parent-button';
//# sourceMappingURL=constants.js.map